<script setup>

</script>

<template>
    <svg width="28" height="27" xmlns="http://www.w3.org/2000/svg">
        <g transform="translate(.767)" fill="none" fill-rule="evenodd">
            <circle fill="#00857C" cx="13.5" cy="13.5" r="13.5"/>
            <path d="M17.273 11.667H11a2 2 0 0 0-2 2V20" stroke="#FFF" stroke-width="3"/>
            <path fill="#FFF" d="m23 11.667-7.382 6.666V5z"/>
        </g>
    </svg>

</template>

<script>
    export default {
        name: "Direction Icon"
    }
</script>

<style scoped lang="scss">

</style>
